import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const StaffModalImgShow = ({ handleClose, cantain }) => {

    const isVideo = (url) =>
        url?.toLowerCase().match(/\.(mp4|m4v|mov|avi|wmv|flv)$/);

    return (
        <>
            <Modal.Header closeButton>
                <Modal.Title>{cantain?.str}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {cantain?.url ? (
                    isVideo(cantain.url) ? (
                        <video controls style={{ width: '100%' }} autoPlay>
                            <source src={cantain.url} type="video/mp4" />
                        </video>
                    ) : (
                        <img
                            src={cantain.url}
                            style={{ width: '100%', height: 'auto' }}
                            alt="Document"
                        />
                    )
                ) : (
                    "Document Not Uploaded"
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </>
    );
};

export default StaffModalImgShow;
